import React, { useEffect } from "react"
import Header from "../components/meeting/Header"
import QuarterlyGoals from "../components/meeting/QuarterlyGoals"
import Pendings from "../components/meeting/Pendings";
import Rating from "../components/meeting/Rating";
import Metrics from "../components/meeting/Metrics";

import { getObjetivesByUser } from "../helpers/meetings/getObjetivesByUser";
import { getMeetingDates } from "../helpers/meetings/getMeetingDates";
import { getPendingByQuarter } from "../helpers/meetings/getPendingsByQuarter";
import { getUsers } from '../helpers/meetings/getUsers';
import { getRating } from "../helpers/meetings/getRating";
import { getMeetingMetrics } from '../helpers/meetings/getMetrics';

import { Divider, Alert } from "antd";

const Meeting = () => {
    const [quarterly, setQuarterly] = React.useState(null);
    const [meetingYear, setMeetingYear] = React.useState(null);
    const [meetingDate, setMeetingDate] = React.useState(null);
    const [loadData, setLoadData] = React.useState(false);
    const [loadDataObjetives, setLoadDataObjetives] = React.useState(false);
    const [loadDataPending, setLoadDataPending] = React.useState(false);
    const [loadDataMetrics, setLoadDataMetrics] = React.useState(false);
    const [loadDataRating, setLoadDataRating] = React.useState(false);
    const [objectives, setObjectives] = React.useState([]);
    const [objectivesEdit, setObjectivesEdit] = React.useState([]);
    const [pendings, setPendings] = React.useState([]);
    const [pendingsEdit, setPendingsEdit] = React.useState([]);
    const [meetingDates, setMeetingDates] = React.useState([]);
    const [users, setUsers] = React.useState([]);

    const [dataMetrics, setDataMetrics] = React.useState([]);
    const [dataMetricsEdit, setDataMetricsEdit] = React.useState([]);

    const [dataRating, setDataRating] = React.useState([]);
    const [dataRatingEdit, setDataRatingEdit] = React.useState([]);

    const [showAlert, setShowAlert] = React.useState(false);
    const [showAlertMetrics, setShowAlertMetrics] = React.useState(false);
    const [showAlertPendings, setShowAlertPendings] = React.useState(false);
    const [showAlertRating, setShowAlertRating] = React.useState(false);
    const [optionAlert, setOptionAlert] = React.useState({});

    const [prom, setProm] = React.useState(0);

    useEffect(() => {
        getUsers().then((response) => {
            if (response.status === "success") {
                setUsers(response.data);
            }
        });
    }, []);

    useEffect(() => {
        if (loadData) {
            setLoadData(false);

            getObjetivesByUser(quarterly, meetingDate).then((response) => {
                if (response.status === "success") {
                    setObjectives(response.data);
                }
            });

            getPendingByQuarter(quarterly).then((response) => {
                if (response.status === "success") {
                    setPendings(response.data);
                }
            });

            getRating(quarterly, meetingDate).then((response) => {
                if (response.status === "success") {
                    let total = 0;

                    response.data.forEach(item => {
                        total += item.rating;
                    });

                    setProm((total / response.data.length).toFixed(1));
                    setDataRating(response.data);
                }
            });

            getMeetingMetrics(quarterly, meetingDate).then((response) => {
                if (response.status === "success") {
                    setDataMetrics(response.data);
                }
            });
        }
    }, [loadData]);

    useEffect(() => {
        if (loadDataRating) {
            setShowAlertRating(false);
            setOptionAlert({});
            setLoadDataRating(false);


            getRating(quarterly, meetingDate).then((response) => {
                if (response.status === "success") {
                    let total = 0;

                    response.data.forEach(item => {
                        total += item.rating;
                    });

                    setProm((total / response.data.length).toFixed(1));
                    setDataRating(response.data);
                }
            });
        }
    }, [loadDataRating]);

    useEffect(() => {
        if (loadDataObjetives) {
            setLoadDataObjetives(false);

            getObjetivesByUser(quarterly, meetingDate).then((response) => {
                if (response.status === "success") {
                    setObjectives(response.data);
                }
            });
        }
    }, [loadDataObjetives]);

    useEffect(() => {
        if (loadDataPending) {
            setShowAlertPendings(false);
            setOptionAlert({});
            setLoadDataPending(false);

            getPendingByQuarter(quarterly).then((response) => {
                if (response.status === "success") {
                    setPendings(response.data);
                }
            });
        }
    }, [loadDataPending]);

    useEffect(() => {
        if (loadDataMetrics) {
            setLoadDataMetrics(false);
            setShowAlertMetrics(false);

            getMeetingMetrics(quarterly, meetingDate).then((response) => {
                if (response.status === "success") {
                    setDataMetrics(response.data);
                }
            });
        }
    }, [loadDataMetrics]);

    useEffect(() => {
        if (quarterly) {
            getMeetingDates(quarterly, meetingYear).then((response) => {
                if (response.status === "success") {
                    setMeetingDates(response.data);
                }
            });
        }
    }, [quarterly]);

    useEffect(() => {
        if (meetingDate) {
            setLoadData(true);
        }
    }, [meetingDate]);

    return <div style={{ height: "95vh", margin: "18px", overflowY: "auto" }}>
        <Header
            setQuarterly={setQuarterly}
            setMeetingDate={setMeetingDate}
            setLoadData={setLoadData}
            meetingDates={meetingDates}
            setMeetingYear={setMeetingYear}
            quarterly={quarterly}
            meetingDate={meetingDate}
        />

        <Divider style={{ margin: "24px 0" }} />

        {showAlert && (

            <Alert
                style={{ width: "98%", marginBottom: "20px" }}
                message={optionAlert.message}
                description={optionAlert.description}
                type={optionAlert.type}
                showIcon
            />
        )}

        <QuarterlyGoals
            objectives={objectives}
            objectivesEdit={objectivesEdit}
            setObjectivesEdit={setObjectivesEdit}
            setLoadDataObjetives={setLoadDataObjetives}
            setShowAlert={setShowAlert}
            setOptionAlert={setOptionAlert}
        />

        <Divider style={{ margin: "24px 0" }} />

        {showAlertMetrics && (
            <Alert
                style={{ width: "98%", marginBottom: "20px" }}
                message={optionAlert.message}
                description={optionAlert.description}
                type={optionAlert.type}
                showIcon
            />
        )}

        <Metrics
            dataMetrics={dataMetrics}
            dataMetricsEdit={dataMetricsEdit}
            setDataMetricsEdit={setDataMetricsEdit}
            setLoadDataMetrics={setLoadDataMetrics}
            quarterly={quarterly}
            meetingDate={meetingDate}
            setShowAlertMetrics={setShowAlertMetrics}
            setOptionAlert={setOptionAlert}
        />

        <Divider style={{ margin: "24px 0" }} />

        {showAlertPendings && (
            <Alert
                style={{ width: "98%", marginBottom: "20px" }}
                message={optionAlert.message}
                description={optionAlert.description}
                type={optionAlert.type}
                showIcon
            />
        )}

        <Pendings
            quarterly={quarterly}
            meetingDate={meetingDate}
            setLoadDataPending={setLoadDataPending}
            pendings={pendings}
            pendingsEdit={pendingsEdit}
            setPendingsEdit={setPendingsEdit}
            users={users}
            setShowAlertPendings={setShowAlertPendings}
            setOptionAlert={setOptionAlert}
        />

        <Divider style={{ margin: "24px 0" }} />

        {showAlertRating && (
            <Alert
                style={{ width: "98%", marginBottom: "20px" }}
                message={optionAlert.message}
                description={optionAlert.description}
                type={optionAlert.type}
                showIcon
            />
        )}

        <Rating
            dataRating={dataRating}
            quarterly={quarterly}
            meetingDate={meetingDate}
            setLoadDataRating={setLoadDataRating}
            dataRatingEdit={dataRatingEdit}
            setDataRatingEdit={setDataRatingEdit}
            prom={prom}
            setProm={setProm}
            setShowAlertRating={setShowAlertRating}
            setOptionAlert={setOptionAlert}
        />
    </div>
}

export default Meeting